
  import React from "react"
  import Component from "/Users/daviddavidson/Desktop/dev/blog/src/layouts/index.js"
  import data from "/Users/daviddavidson/Desktop/dev/blog/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js